import { Phone, Clock, TrendingUp, Users } from 'lucide-react';

export default function Stats({ calls }) {
  const totalCalls = calls.length;
  const totalDuration = calls.reduce((sum, call) => sum + (call.call_duration_seconds || 0), 0);
  const avgDuration = totalCalls > 0 ? totalDuration / totalCalls : 0;
  
  const uniqueWorkflows = new Set(calls.map(call => call.workflow_id)).size;

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
  };

  const stats = [
    {
      name: 'Total Calls',
      value: totalCalls,
      icon: Phone,
      color: 'bg-blue-500',
      bgColor: 'bg-blue-50',
    },
    {
      name: 'Total Duration',
      value: formatTime(totalDuration),
      icon: Clock,
      color: 'bg-green-500',
      bgColor: 'bg-green-50',
    },
    {
      name: 'Avg Duration',
      value: formatTime(avgDuration),
      icon: TrendingUp,
      color: 'bg-purple-500',
      bgColor: 'bg-purple-50',
    },
    {
      name: 'Agents',
      value: uniqueWorkflows,
      icon: Users,
      color: 'bg-orange-500',
      bgColor: 'bg-orange-50',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {stats.map((stat) => (
        <div key={stat.name} className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">{stat.name}</p>
              <p className="mt-2 text-3xl font-semibold text-gray-900">{stat.value}</p>
            </div>
            <div className={`${stat.bgColor} p-3 rounded-lg`}>
              <stat.icon className={`w-6 h-6 text-${stat.color.replace('bg-', '')}`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
